// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__WXuN4","Logo_heading":"Logo_Logo_heading__T5hd6","Logo_asset":"Logo_Logo_asset__2nKJz","Logo_asset___isSmall":"Logo_Logo_asset___isSmall__PKZAn"};